<div class="list-item">
  <app-photo
    size="m"
    [rounded]="true"
    [type]="'photo'"
    [id]="data?.photoPath"
    [text]="data | userDisplayableName: 'short'"
  ></app-photo>

  <div class="list-item__info">
    <div class="list-item__title">
      <span class="list-item__text text_size-m text_color-01 text_truncate">
        {{ data | userDisplayableName }}
      </span>
    </div>

    <span
      *ngFor="let organisationJobTitle of jobTitles"
      class="list-item__text text_size-xs text_color-03 text_truncate"
    >
      {{ organisationJobTitle | orgJobTitleDisplayableName }}
    </span>

    <span
      *ngIf="data && data.decisionTypeName"
      class="list-item__status"
      [class.list-item__status_blue]="data.decisionTypeCode === 0 || data.decisionTypeCode === 1"
      [class.list-item__status_green]="data.decisionTypeCode === 2 || data.decisionTypeCode === 4"
      [class.list-item__status_red]="data.decisionTypeCode === 3"
    >
      {{ data.decisionTypeName }}
    </span>
  </div>
</div>
